import Footer from "../footer/Footer";
import { Helmet } from "react-helmet";
import React, { useState, useEffect, useRef } from "react";

import { Trans, useTranslation } from "react-i18next";
import EsnadStructureDe from "../../assets/esnad-Structure-de.svg";
import EsnadStructureAr from "../../assets/esnad-Structure-ar.svg";

import "./Pages.css";

const Board = () => {
  const { i18n } = useTranslation();
  let currentLanguage = i18n.language;
  const [structureImage, setStructureImage] = useState(0);
  const images = [EsnadStructureDe, EsnadStructureAr];
  const [lang, setLang] = useState(currentLanguage)
 
  useEffect(() => {
    window.addEventListener('storage', () => {
      console.log("Change to local storage!");
      setLang(window.localStorage.getItem("lang"))      
    })
  }, [lang]);

  useEffect(()=>{
    if (lang === "ye-YE") {
      setStructureImage(1);
    } else if (lang === "de-DE") {
      setStructureImage(0);
    }
  }, [lang])
  
  return (
    <div>
      <div className="about-board">
        <Helmet>
          <title>Esnad e.V | Board| Vorstand</title>
        </Helmet>
        <Trans
          i18nKey="Board-Content"
          components={{
            p: <p />,
            pre: <pre />,
            h4: <h4 />,
            ul: <ul />,
            li: <li />,
            strong: <strong />,
            h5: <h5 />
          }}
        />
        <img
          width={900}
          height={700}
          src={images[structureImage]}
          alt="ESNAD Organisatorische Struktur"
        />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Board;
